import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import { push as pushAction } from 'connected-react-router'
import {
  setSnackbar as setSnackbarAction,
  popSnackbar as popSnackbarAction,
} from 'actions/Control'
import { withAuditMissionAuthorization } from 'wrappers'
import PictoLoader from 'components/PictoLoader'
import PageForLoggedAndAuthorizedUser from 'app/PageForLoggedAndAuthorizedUser'
import PageNotLoggedUser from 'app/PageNotLoggedUser'
import { useAuthContext } from 'contexts/auth'
import cache from 'api/utils/CacheHandler'
import { useTranslation } from 'react-i18next'
// import { useApiContext } from 'contexts/api'
// import { attachPendingRequestHandler } from 'api/utils/pendingRequestHandler'

const App = (props) => {
  const {
    location: { pathname, search = '' },
    snackbar,
    authorized,
    pendingAuthorization,
    setSnackbar,
    popSnackbar,
    push,
    loadingAuditMission,
  } = props

  const { t } = useTranslation('routes')

  // const { apiCall } = useApiContext()
  const { token, logPending, notLogged, isLogged, logOut } = useAuthContext()
  const [hasUnsyncedRequests, setHasUnsyncedRequests] = useState(false)
  const requestedToken = new URLSearchParams(search).get('token')
  const shouldSwitchMission =
    isLogged &&
    pathname === '/sign_in' &&
    requestedToken &&
    requestedToken !== token

  useEffect(() => {
    // if (isLogged) attachPendingRequestHandler(apiCall, popSnackbar)
  }, [logPending])

  useEffect(() => {
    let mounted = true

    if (shouldSwitchMission) {
      Promise.all([
        cache.countPendingRequests(),
        cache.countfailedRequests(),
      ]).then(([pendingRequests, failedRequests]) => {
        if (mounted) {
          setHasUnsyncedRequests(pendingRequests + failedRequests > 0)
        }
      })
    }

    return () => {
      mounted = false
    }
  }, [shouldSwitchMission])

  const loggedAndUnauthorized =
    isLogged && pendingAuthorization === false && authorized === false
  const loggedAndAuthorized =
    isLogged && pendingAuthorization === false && authorized === true

  const cancelMissionSwitch = () => push('/')
  const confirmMissionSwitch = () => {
    logOut(() => window.location.assign(`${pathname}${search}`))
  }

  if (logPending) {
    return null
  }

  if (notLogged) {
    if (pathname === '/sign_in') {
      return (
        <>
          {loadingAuditMission && <PictoLoader />}
          <PageNotLoggedUser snackbar={snackbar} setSnackbar={setSnackbar} />
        </>
      )
    }
    push('/sign_in')
    return null
  }

  if (loggedAndAuthorized) {
    if (shouldSwitchMission) {
      return (
        <Dialog open onClose={cancelMissionSwitch}>
          <DialogTitle>{t('routes:app.switch_mission.title')}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t(
                hasUnsyncedRequests
                  ? 'routes:app.switch_mission.unsynced_warning'
                  : 'routes:app.switch_mission.confirmation',
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelMissionSwitch} color="primary">
              {t('routes:app.switch_mission.cancel')}
            </Button>
            <Button onClick={confirmMissionSwitch} color="primary">
              {t('routes:app.switch_mission.confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      )
    }
    if (pathname === '/sign_in') {
      popSnackbar(t('routes:app.already_connected'))
      push('/')
      return null
    }
    return (
      <>
        {loadingAuditMission && <PictoLoader />}
        <PageForLoggedAndAuthorizedUser
          snackbar={snackbar}
          setSnackbar={setSnackbar}
        />
      </>
    )
  }

  if (loggedAndUnauthorized) logOut()

  return null
}

const mapStateToProps = (state) => ({
  snackbar: state.control.snackbar,
})

const mapDispatchToProps = (dispatch) => ({
  setSnackbar: (theme) => dispatch(setSnackbarAction(theme)),
  popSnackbar: (msg, type = 'warning') =>
    dispatch(popSnackbarAction(msg, type)),
  push: (path) => dispatch(pushAction(path)),
})

export default withAuditMissionAuthorization(
  connect(mapStateToProps, mapDispatchToProps)(App),
)
